import { isRejectedWithValue } from '@reduxjs/toolkit'
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit'
import { setNotification } from './general/slice'

export const errorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action) && typeof action.payload !== 'object') {
        api.dispatch(setNotification([action.payload || 'Server Error ...', 'error']));
    }

    return next(action);
};